import React, { useState, useRef } from "react";
import awardImage from "../assets/sltc-award-2025.jpg";

const NewsAchievements = () => {
  const [activeNews, setActiveNews] = useState(0);
  const [isHighlighted, setIsHighlighted] = useState(false);
  const sectionRef = useRef(null);

  const handleLearnMore = () => {
    // Open external URL in new tab with security attributes
    window.open(
      "https://www.dailymirror.lk/press_releases/SLTC-Research-and-Innovation-Awards-2025-Honoring-Research-that-Matters-for-Society-Beyond/335-327157",
      "_blank",
      "noopener,noreferrer"
    );
  };

  const newsItems = [
    {
      icon: "🏆",
      badge: "AWARD RECOGNITION",
      title: "Excellence in In-house R&D Award 2025",
      subtitle: "SLTC Research & Innovation Awards 2025",
      date: "2025",
      description: "Recognized with the prestigious 'Excellence in In-house R&D' Award under the ICT and Digital Innovation Research sector at the SLTC Research & Innovation Awards 2025.",
      highlights: [
        "National recognition for healthcare innovation",
        "Excellence in research and development",
        "AI-powered digital healthcare transformation",
        "Commitment to improving healthcare accessibility"
      ],
      details: "HelaDoc is proud to be recognized for our commitment to research excellence, innovation, and technological advancement. The award reflects the dedication of our research and development team, strategic partners, and supporters who continue to drive meaningful healthcare innovation.",
      color: "from-amber-50 to-orange-50",
      accentColor: "text-amber-600",
      borderColor: "border-amber-200"
    },
    {
      icon: "🚀",
      badge: "PARTNERSHIP OPPORTUNITY",
      title: "Join Us in Transforming Healthcare with AI",
      date: "2025",
      description: "HelaDoc is actively seeking visionary investors, strategic partners, healthcare institutions, and technology collaborators.",
      highlights: [
        "Scalable AI-powered healthcare ecosystem",
        "Expanding digital health market opportunities",
        "Meaningful social impact through healthcare accessibility",
        "Strong innovation-focused product and R&D team"
      ],
      details: "As a next-generation healthcare ecosystem, HelaDoc seamlessly connects patients, doctors, pharmacies, laboratories, and insurance providers through a unified digital platform powered by artificial intelligence. With a clear roadmap toward MVP launch and growing demand for digital healthcare solutions, HelaDoc presents a unique opportunity for high-impact collaboration and long-term growth.",
      cta: "Become part of the future of healthcare innovation",
      color: "from-blue-50 to-cyan-50",
      accentColor: "text-blue-600",
      borderColor: "border-blue-200"
    },
    {
      icon: "🎉",
      badge: "MILESTONE ACHIEVEMENT",
      title: "A Proud Milestone for\nPahanmi Group & HelaDoc",
      date: "2025",
      description: "Officially received national recognition from the Sri Lanka Technology Campus (SLTC) for outstanding contributions to research and innovation.",
      highlights: [
        "Build AI-driven healthcare solutions for Sri Lanka",
        "Lead innovation through research and technology",
        "Create real-world impact through digital transformation",
        "Many more innovations on the horizon"
      ],
      details: "What began as a bold vision has evolved into a nationally recognized healthcare innovation platform. This milestone belongs to our dedicated R&D team, mentors, partners, and everyone who believes in the power of technology to improve lives.",
      color: "from-emerald-50 to-teal-50",
      accentColor: "text-emerald-600",
      borderColor: "border-emerald-200"
    }
  ];

  const activeItem = newsItems[activeNews];

  return (
    <>
      <style>{`
        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        .news-header {
          animation: slideInUp 0.8s ease-out;
        }

        .news-card {
          animation: slideInUp 0.6s ease-out;
          transition: all 0.3s ease;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        .news-card::before {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(255,255,255,0.1), rgba(255,255,255,0));
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .news-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        }

        .news-card:hover::before {
          opacity: 1;
        }

        .news-card.active {
          transform: scale(1.02);
          box-shadow: 0 20px 50px rgba(59, 130, 246, 0.2);
        }

        .featured-content {
          animation: fadeIn 0.5s ease-out;
        }

        .badge-icon {
          animation: scaleIn 0.4s ease-out;
          display: inline-block;
        }

        .highlight-item {
          animation: slideInUp 0.6s ease-out;
          transition: all 0.3s ease;
        }

        .highlight-item:nth-child(1) { animation-delay: 0.1s; }
        .highlight-item:nth-child(2) { animation-delay: 0.2s; }
        .highlight-item:nth-child(3) { animation-delay: 0.3s; }
        .highlight-item:nth-child(4) { animation-delay: 0.4s; }

        .achievement-badge {
          display: inline-block;
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.5px;
          text-transform: uppercase;
          background: rgba(59, 130, 246, 0.1);
          color: rgb(59, 130, 246);
          margin-bottom: 12px;
        }

        .title-with-break {
          white-space: pre-wrap;
          word-break: break-word;
        }

        .timeline-dot {
          width: 12px;
          height: 12px;
          background: currentColor;
          border-radius: 50%;
          margin-right: 12px;
          flex-shrink: 0;
          animation: pulse 2s ease-in-out infinite;
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.6;
            transform: scale(1.1);
          }
        }

        @keyframes iconFloat {
          0%, 100% {
            transform: translateY(0px) rotate(0deg);
          }
          50% {
            transform: translateY(-12px) rotate(5deg);
          }
        }

        .stat-icon {
          display: inline-block;
          animation: iconFloat 3s ease-in-out infinite;
          transition: all 0.3s ease;
        }

        .stat-icon:hover {
          animation: none;
          transform: scale(1.2) rotate(10deg);
        }

        @keyframes highlight {
          0% {
            box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.7), 0 20px 50px rgba(59, 130, 246, 0.2);
          }
          50% {
            box-shadow: 0 0 30px 15px rgba(59, 130, 246, 0.3), 0 20px 50px rgba(59, 130, 246, 0.3);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(59, 130, 246, 0), 0 20px 50px rgba(59, 130, 246, 0.15);
          }
        }

        .section-highlight {
          animation: highlight 2s ease-out 1;
        }

        .award-caption {
          text-center text-sm font-semibold text-gray-600 mb-8;
          font-style: italic;
        }

        .award-divider {
          height: 100%;
          width: 2px;
          background: linear-gradient(to bottom, 
            rgba(59, 130, 246, 0),
            rgba(59, 130, 246, 0.3),
            rgba(59, 130, 246, 0)
          );
        }

        .featured-layout-award {
          display: grid;
          grid-template-columns: 52% 2px 1fr;
          gap: 0;
          align-items: stretch;
          min-height: 560px;
        }

        .featured-image-section {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 32px 28px;
          border-radius: 16px 0 0 16px;
          overflow: hidden;
          background: transparent;
        }

        .award-image {
          width: 100%;
          height: 100%;
          min-height: 520px;
          object-fit: contain;
          border-radius: 12px;
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
          transition: transform 0.4s ease, filter 0.4s ease;
        }

        .award-image:hover {
          transform: scale(1.02);
          filter: brightness(1.08);
          box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
        }

        .featured-content-section {
          padding: 44px 40px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          border-radius: 0 16px 16px 0;
          background: rgba(255, 255, 255, 0.1);
        }

        @media (max-width: 1024px) {
          .featured-layout-award {
            grid-template-columns: 1fr;
            gap: 28px;
            min-height: auto;
          }

          .featured-image-section {
            border-radius: 16px;
            padding: 0;
          }

          .featured-content-section {
            border-radius: 16px;
            padding: 36px;
          }

          .award-image {
            min-height: 340px;
            border-radius: 16px;
          }

          .award-divider {
            display: none;
          }
        }
      `}</style>

      <section id="news-achievements" ref={sectionRef} className={`py-24 bg-white transition-all duration-300 ${isHighlighted ? "section-highlight" : ""}`}>
        <div className="max-w-7xl mx-auto px-6">
          {/* Header */}
          <div className="text-center max-w-3xl mx-auto mb-16 news-header">
            <span className="inline-flex items-center gap-2 bg-blue-100 border border-blue-300 rounded-full px-4 py-2 text-xs font-semibold text-blue-700 mb-6">
              <span className="w-2 h-2 bg-blue-700 rounded-full" />
              Latest News & Achievements
            </span>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Recognition & Innovation Milestones
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed">
              Celebrating our journey of innovation, research excellence, and commitment to transforming digital healthcare in Sri Lanka.
            </p>
          </div>

          {/* News Cards Navigation */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {newsItems.map((item, idx) => (
              <div
                key={idx}
                onClick={() => setActiveNews(idx)}
                className={`news-card rounded-2xl p-6 border-2 transition-all ${
                  activeNews === idx
                    ? `bg-gradient-to-br ${item.color} ${item.borderColor} border-solid`
                    : "bg-white border-gray-100 hover:border-gray-200"
                }`}
              >
                <div className="text-5xl mb-4">{item.icon}</div>
                <div className="achievement-badge">{item.badge}</div>
                <h3 className="text-lg font-bold text-gray-900 mb-3 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-600 mb-4">{item.date}</p>
                <p className="text-sm text-gray-600 line-clamp-2">{item.description}</p>
              </div>
            ))}
          </div>

          {/* Featured Content */}
          <div className={`featured-content rounded-3xl bg-gradient-to-br ${activeItem.color} border-2 ${activeItem.borderColor} overflow-hidden relative`}>
            
            {/* Award Recognition Card - Side Layout */}
            {activeNews === 0 ? (
              <div className="featured-layout-award">

                {/* Content Section */}
                <div className="featured-content-section">
                  <div className="mb-6">
                    <div className="badge-icon text-5xl mb-4">{activeItem.icon}</div>
                    <div className="achievement-badge">{activeItem.badge}</div>
                  </div>
                  
                  <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2 leading-tight title-with-break">
                    {activeItem.title}
                  </h2>
                  {activeItem.subtitle && (
                    <h3 className="text-lg text-gray-700 font-semibold mb-4 leading-tight">
                      {activeItem.subtitle}
                    </h3>
                  )}
                  
                  <p className="text-gray-700 text-base leading-relaxed mb-6">
                    {activeItem.details}
                  </p>

                  {activeItem.cta && (
                    <p className="text-lg font-semibold text-gray-900 italic border-l-4 border-blue-600 pl-4 py-2 bg-white/40 rounded-r-lg mb-6">
                      "{activeItem.cta}"
                    </p>
                  )}

                  <div className="space-y-3 mb-8">
                    <h4 className="text-lg font-bold text-gray-900">Key Highlights:</h4>
                    {activeItem.highlights.map((highlight, idx) => (
                      <div key={idx} className="highlight-item flex items-start gap-3 bg-white/60 rounded-lg p-3 backdrop-blur-sm">
                        <div className={`timeline-dot ${activeItem.accentColor}`} />
                        <p className="text-gray-800 font-medium leading-relaxed text-sm">{highlight}</p>
                      </div>
                    ))}
                  </div>

                  <button 
                    onClick={handleLearnMore}
                    className={`inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-white bg-gradient-to-r from-blue-600 to-cyan-600 hover:shadow-lg hover:shadow-blue-600/30 hover:scale-105 transition-all duration-300 shadow-lg w-fit`}>
                    Learn More
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                  </button>
                </div>

                {/* Award Image Section - Right Side */}
                <div className="award-divider"></div>
                <div className="featured-image-section">
                  <img 
                    src={awardImage} 
                    alt="Excellence in In-house R&D Award 2025" 
                    className="award-image"
                  />
                </div>
              </div>
            ) : (
              /* Original Layout for Other Cards */
              <>
                <div className="p-12">
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    {/* Left Content */}
                    <div>
                      <div className="mb-6">
                        <div className="badge-icon text-6xl mb-4">{activeItem.icon}</div>
                        <div className="achievement-badge">{activeItem.badge}</div>
                      </div>
                      
                      <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2 leading-tight title-with-break">
                        {activeItem.title}
                      </h2>
                      {activeItem.subtitle && (
                        <h3 className="text-lg text-gray-700 font-semibold mb-4 leading-tight">
                          {activeItem.subtitle}
                        </h3>
                      )}
                      
                      <p className="text-gray-700 text-lg leading-relaxed mb-6">
                        {activeItem.details}
                      </p>

                      {activeItem.cta && (
                        <p className="text-lg font-semibold text-gray-900 italic border-l-4 border-blue-600 pl-4 py-2 bg-white/40 rounded-r-lg">
                          "{activeItem.cta}"
                        </p>
                      )}
                    </div>

                    {/* Right Content - Highlights */}
                    <div className="space-y-4">
                      <h3 className="text-2xl font-bold text-gray-900 mb-6">Key Highlights</h3>
                      {activeItem.highlights.map((highlight, idx) => (
                        <div key={idx} className="highlight-item flex items-start gap-4 bg-white/60 rounded-xl p-4 backdrop-blur-sm">
                          <div className={`timeline-dot ${activeItem.accentColor}`} />
                          <p className="text-gray-800 font-medium leading-relaxed">{highlight}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* CTA Button */}
                  <div className="mt-12 flex justify-center">
                    <button 
                      onClick={handleLearnMore}
                      className={`inline-flex items-center gap-2 px-8 py-4 rounded-full font-semibold text-white bg-gradient-to-r from-blue-600 to-cyan-600 hover:shadow-lg hover:shadow-blue-600/30 hover:scale-105 transition-all duration-300 shadow-lg`}>
                      Learn More
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                      </svg>
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Timeline Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
            {[
              { number: "🏆", label: "Awards & Recognition", desc: "National honors for innovation" },
              { number: "🤝", label: "Strategic Partnerships", desc: "Growing ecosystem collaborations" },
              { number: "🚀", label: "Continuous Innovation", desc: "Next-generation healthcare solutions" }
            ].map((stat, idx) => (
              <div key={idx} className="text-center p-8 rounded-2xl bg-gradient-to-br from-slate-50 to-blue-50 border border-slate-200 hover:border-blue-300 transition-all hover:shadow-lg">
                <div className="stat-icon text-5xl mb-4">{stat.number}</div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">{stat.label}</h4>
                <p className="text-gray-600">{stat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default NewsAchievements;
